(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hello-buy-now"] && !Shopify.designMode) return;
  try {
    class HelloBuyNow extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-hello-buy-now]');
      if (this.button) {
        this.button.addEventListener('click', this.onClick.bind(this));
      }
    }

    onClick(event) {
      event.preventDefault();

      const form =
        document.querySelector('product-form-component form') ||
        document.querySelector('form[action*="/cart/add"]');

      if (!form) {
        window.location.href = '/cart';
        return;
      }

      const idEl = form.querySelector('[name="id"]');
      const qtyEl = form.querySelector('[name="quantity"]');

      if (!idEl || !idEl.value) {
        window.location.href = '/cart';
        return;
      }

      const payload = {
        id: idEl.value,
        quantity: qtyEl && qtyEl.value ? parseInt(qtyEl.value, 10) : 1,
      };

      const button = this.button;
      button.setAttribute('disabled', '');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('add-to-cart failed');
          }
          return response.json();
        })
        .then(() => {
          if (typeof window.yampiClick === 'function') {
            window.yampiClick();
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(() => {
          button.removeAttribute('disabled');
          window.location.href = '/cart';
        });
    }
  }

  if (!customElements.get('hello-buy-now')) {
    customElements.define('hello-buy-now', HelloBuyNow);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hello-payment-options"] && !Shopify.designMode) return;
  try {
    (function () {
    var brl = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

    function formatBRL(value) {
      return brl.format(value);
    }

    function parseBRL(text) {
      if (!text) return null;
      var clean = text.replace(/[^0-9.,]/g, '').replace(/\./g, '').replace(',', '.');
      var value = parseFloat(clean);
      return isNaN(value) ? null : value;
    }

    class HelloPaymentOptions extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.hpo__trigger');
        this.dialog = this.querySelector('.hpo__dialog');
        this.closeBtn = this.querySelector('.hpo__close');
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('.hpo__tab'));
        this.panels = Array.prototype.slice.call(this.querySelectorAll('.hpo__panel'));

        if (this.trigger) this.trigger.addEventListener('click', this.open.bind(this));
        if (this.closeBtn) this.closeBtn.addEventListener('click', this.close.bind(this));
        if (this.dialog) {
          this.dialog.addEventListener(
            'click',
            function (event) {
              if (event.target === this.dialog) this.close();
            }.bind(this)
          );
        }
        this.tabs.forEach(
          function (tab) {
            tab.addEventListener(
              'click',
              function () {
                this.switchTab(tab.getAttribute('data-tab'));
              }.bind(this)
            );
          }.bind(this)
        );
      }

      open() {
        this.build();
        if (this.dialog.showModal) {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
      }

      close() {
        if (this.dialog.close) {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
        }
      }

      switchTab(name) {
        this.tabs.forEach(function (tab) {
          tab.classList.toggle('is-active', tab.getAttribute('data-tab') === name);
        });
        this.panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-panel') !== name;
        });
      }

      getPrice() {
        var scope = this.closest('.product-details') || document;
        var priceEl = scope.querySelector('product-price') || document.querySelector('product-price');
        if (!priceEl) return null;

        var target = null;
        var sale = priceEl.querySelector('.price__sale');
        var regular = priceEl.querySelector('.price__regular');
        if (sale && !sale.classList.contains('price__hidden')) {
          target = sale.querySelector('.price-item--sale') || sale.querySelector('.price');
        } else if (regular) {
          target = regular.querySelector('.price');
        }
        if (!target) target = priceEl.querySelector('.price');
        return target ? parseBRL(target.textContent) : null;
      }

      build() {
        var price = this.getPrice();
        if (price == null) return;

        var max = parseInt(this.getAttribute('data-max') || '12', 10);
        var free = parseInt(this.getAttribute('data-free') || '6', 10);
        var rate = parseFloat((this.getAttribute('data-rate') || '0').replace(',', '.')) / 100;
        var minValue = parseFloat(this.getAttribute('data-min') || '0');

        var rows = '';
        for (var n = 1; n <= max; n++) {
          var perInstallment;
          var total;
          var hasInterest;
          if (n <= free || rate <= 0) {
            perInstallment = price / n;
            total = price;
            hasInterest = false;
          } else {
            perInstallment = (price * rate) / (1 - Math.pow(1 + rate, -n));
            total = perInstallment * n;
            hasInterest = true;
          }
          if (n > 1 && minValue > 0 && perInstallment < minValue) break;

          var left =
            n === 1
              ? 'À vista'
              : n + 'x ' + formatBRL(perInstallment) + (hasInterest ? '' : ' s/juros');
          rows +=
            '<tr><td class="hpo__cell-left">' +
            left +
            '</td><td class="hpo__cell-right">Total: ' +
            formatBRL(total) +
            '</td></tr>';
        }

        var cardBody = this.querySelector('[data-panel="card"] tbody');
        if (cardBody) cardBody.innerHTML = rows;

        this.fillSingle('pix', price, parseFloat(this.getAttribute('data-pix-discount') || '0'));
        this.fillSingle('boleto', price, parseFloat(this.getAttribute('data-boleto-discount') || '0'));
      }

      fillSingle(name, price, discount) {
        var body = this.querySelector('[data-panel="' + name + '"] tbody');
        if (!body) return;
        var finalValue = discount > 0 ? price * (1 - discount / 100) : price;
        var label = discount > 0 ? 'À vista (' + discount + '% de desconto)' : 'À vista';
        body.innerHTML =
          '<tr><td class="hpo__cell-left">' +
          label +
          '</td><td class="hpo__cell-right">Total: ' +
          formatBRL(finalValue) +
          '</td></tr>';
      }
    }

    if (!customElements.get('hello-payment-options')) {
      customElements.define('hello-payment-options', HelloPaymentOptions);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
